import { Row, Tabs, TabsProps } from "antd";
import { useCallback, useMemo, useState } from "react";
import { Details } from "./Details";
import { PaymentHistory } from "./PaymentHistory";
import { AccountHeader } from "../../AccountHeader";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { ITaxInfo } from "./PaymentHistory/types";
import { Error } from "../../../../../components/Error";
import { useFetchExternalPortalAccountData } from "../../../../../lib/hooks/useFetchExternalPortalAccountData";
import { Loader } from "../../../../../components/Loader";

type UserViewProps = {
  accountNumber: number;
};

export const UserView = ({ accountNumber }: UserViewProps) => {
  const navigate: NavigateFunction = useNavigate();

  const [error, setError] = useState<string | null>(null);

  const { data, roleInfo, isLoading } = useFetchExternalPortalAccountData(
    accountNumber,
    setError,
  );

  const taxInfo: ITaxInfo | undefined = useMemo(() => {
    if (data) {
      return {
        isBuyer: roleInfo.isBuyer,
        beginningDate: data.generalInformation.beginningDate,
      };
    }
  }, [data, roleInfo]);

  const tabItems: TabsProps["items"] = useMemo(() => {
    return [
      {
        key: "1",
        label: "Account Details",
        children: <Details accountData={data} />,
      },
      {
        key: "2",
        label: "Payment History",
        children: (
          <PaymentHistory
            taxInfo={taxInfo!}
            roleInfo={roleInfo}
            accountNumber={accountNumber}
          />
        ),
      },
    ];
  }, [data, taxInfo, roleInfo, accountNumber]);

  const onBackButtonClicked = useCallback(() => navigate(-1), [navigate]);

  return (
    <Row className="d-block logged-in__page account-view__container">
      {!error ? (
        <>
          {isLoading ? (
            <Loader fontSize="128px" />
          ) : (
            <>
              <Row className="py-5 px-8 align-center title justify-space-between header-container">
                <AccountHeader
                  accountNumber={data.generalInformation.accountNumber}
                  xRef={data.generalInformation.xRef}
                  accountStatus={data.generalInformation.status}
                  onBackButtonClicked={onBackButtonClicked}
                  enableSearch={false}
                />
              </Row>
              <Row className="account-tabs user">
                <Tabs items={tabItems} />
              </Row>
            </>
          )}
        </>
      ) : (
        <Error
          accountNumber={accountNumber}
          error={error}
          onBackButtonClicked={onBackButtonClicked}
          showHeader
        />
      )}
    </Row>
  );
};
